import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncWithdrawContractWarning = loadable(
  () => import('./Warning'),
  { fallback: <Loader /> },
);
